module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Ações Extras do Passo \"" + _vm._s(_vm.step.name) + "\"")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-add-field",
      "to": {
        name: 'StepActionDetail',
        params: {
          stepId: _vm.$route.params.stepId
        }
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Ação\n    ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.updating) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.actions.length) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "msg-no-fields"
    }
  }, [_vm._v("\n      O passo ainda não possui ações cadastradas.\n    ")]) : _c('draggable', {
    staticClass: "list-group",
    on: {
      "end": _vm.checkMove
    },
    model: {
      value: (_vm.actions),
      callback: function($$v) {
        _vm.actions = $$v
      },
      expression: "actions"
    }
  }, _vm._l((_vm.actions), function(f, index) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [_c('span', [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [(f.type == 'form') ? _c('span', {
      staticClass: "glyphicon glyphicon-text-size"
    }) : _vm._e(), _vm._v(" "), (f.type == 'link') ? _c('span', {
      staticClass: "glyphicon glyphicon-link"
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(f.name) + "\n                    "), _c('span', {
      staticClass: "pull-right"
    }, [(f.type == 'form') ? _c('router-link', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "to": {
          name: 'StepFieldList',
          params: {
            stepId: _vm.$route.params.stepId,
            actionId: f.objectId
          }
        },
        "type": "button",
        "title": "Adicionar/Editar Campos do Formulário"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }), _vm._v(" Campos do Formulário\n                      ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          name: 'StepActionDetail',
          params: {
            stepId: _vm.$route.params.stepId,
            id: f.objectId
          }
        },
        "type": "button",
        "title": "Editar Ação"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    }), _vm._v(" Editar\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "title": "Remover Ação"
      },
      on: {
        "click": function($event) {
          return _vm.remove(f)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove"
    }), _vm._v(" Remover\n                      ")])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(f.description))])])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Voltar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1d75996"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepActionList.vue
// module id = 1419
// module chunks = 1